export default __webpack_public_path__ + "static/media/tips.9efef5ff.svg";